import { render, staticRenderFns } from "./StudentsEditDataPersonal.vue?vue&type=template&id=88001bdc&scoped=true&"
import script from "./StudentsEditDataPersonal.vue?vue&type=script&lang=js&"
export * from "./StudentsEditDataPersonal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsEditDataPersonal.vue?vue&type=style&index=0&id=88001bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88001bdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCard,VCheckbox,VCol,VContainer,VForm,VRow,VTextField,VTextarea})
